import React from 'react';
import { Loading } from "../../components/Loading/Loading";

const SeriesSelection = ({ seriesList, selectedIndex, onSelect, onAdvance, onClose }) => {
    if (!Array.isArray(seriesList) || seriesList.length === 0) {
        return (
            <div className="loading-wrapper">
                <Loading />
            </div>
        );
    }

    return (
        <div className="series-container">
            <h2 className="serie-title">Selecione a série que pretende subscrever</h2>
            <div className="series-grid">
                {seriesList.map((serie, idx) => (
                    <label key={idx} className={`series-card ${selectedIndex === idx ? 'selected' : ''}`}>
                        <input
                            type="radio"
                            name="serie"
                            checked={selectedIndex === idx}
                            onChange={() => onSelect(serie, idx)}
                        />
                        <div className="series-content">
                            <div className="serie-nome">{serie.nome}</div>
                            <a href={serie.documentos} className="serie-texto" target="_blank" rel="noopener noreferrer">
                                {serie.texto}
                            </a>
                            <div className="serie-descricao">{serie.descricao}</div>
                        </div>
                    </label>
                ))}
            </div>
            <div className="serie-buttons">
                <button className="botao voltar" onClick={onClose}>Voltar</button>
                <button className="botao laranja" onClick={onAdvance} disabled={selectedIndex === null}>Avançar</button>
            </div>
        </div>
    );
};

export default SeriesSelection;
